import { render } from "./SeverityScale.vue?vue&type=template&id=c73425e6&scoped=true"
import script from "./SeverityScale.vue?vue&type=script&lang=js"
export * from "./SeverityScale.vue?vue&type=script&lang=js"

import "./SeverityScale.vue?vue&type=style&index=0&id=c73425e6&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c73425e6"]])

export default __exports__